@if (breadcrumbs(); as breadcrumbs) {
  <section>
    <ppg-breadcrumbs [breadcrumbs]="breadcrumbs" [rootName]="breadcrumbsHome()" />
  </section>
}

@if (page()) {
  <ng-container [ngComponentOutlet]="pageRendererComponent$ | async" [ngComponentOutletInputs]="componentInputs()" />
}
